import axios from 'axios';
import { API_URL, GUEST_TOKEN } from '../config';

// 创建 axios 实例
const tagApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 使用从 config.js 导入的 GUEST_TOKEN

// 添加请求拦截器，自动添加 token
tagApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || GUEST_TOKEN;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 标签服务
const tagService = {
  // 获取所有标签
  getAllTags: async () => {
    try {
      const response = await tagApi.get('/api/tags');
      return response.data.data;
    } catch (error) {
      console.error('获取标签失败:', error);
      throw error;
    }
  },

  // 搜索标签（模糊匹配）
  searchTags: async (query) => {
    try {
      const response = await tagApi.get(`/api/tags?filters[name][$containsi]=${query}`);
      return response.data.data;
    } catch (error) {
      console.error('搜索标签失败:', error);
      throw error;
    }
  },

  // 精确匹配标签
  findExactTag: async (name) => {
    try {
      const response = await tagApi.get(`/api/tags?filters[name][$eq]=${name}`);
      return response.data.data;
    } catch (error) {
      console.error('精确匹配标签失败:', error);
      throw error;
    }
  },

  // 创建新标签（带重复检查）- 使用后端的重复检查逻辑
  createTag: async (name) => {
    try {
      const trimmedName = name.trim();
      if (!trimmedName) {
        throw new Error('标签名称不能为空');
      }

      // 确保有 token
      const token = localStorage.getItem('token') || GUEST_TOKEN;
      
      // 直接调用后端创建接口，后端会自动处理重复检查
      const response = await axios.post(`${API_URL}/api/tags`, {
        data: {
          name: trimmedName,
          slug: trimmedName.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')
        }
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      
      console.log('Tag created/found successfully:', response.data);
      return response.data.data;
    } catch (error) {
      console.error('创建标签失败:', error);
      throw error;
    }
  },

  // 批量创建或查找标签 - 使用新的后端 API
  findOrCreateTags: async (tagNames) => {
    if (!Array.isArray(tagNames) || tagNames.length === 0) {
      return [];
    }

    // 过滤空标签名
    const validTagNames = tagNames
      .map(name => name.trim())
      .filter(name => name.length > 0);

    if (validTagNames.length === 0) {
      return [];
    }

    try {
      // 确保有 token
      const token = localStorage.getItem('token') || GUEST_TOKEN;

      // 调用批量处理接口
      const response = await axios.post(`${API_URL}/api/tags/find-or-create`, {
        tagNames: validTagNames
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        timeout: 10000 // 10秒超时
      });

      console.log('Batch tags processed successfully:', response.data);
      return response.data.data || [];
    } catch (error) {
      console.error('批量处理标签失败:', error);

      // 如果是403错误，尝试刷新token
      if (error.response?.status === 403) {
        console.log('检测到403错误，尝试使用新的token...');
        // 可以在这里尝试重新获取token或者使用默认处理
      }

      // 如果批量接口失败，回退到逐个处理
      console.log('回退到逐个处理标签...');

      const results = [];
      for (const tagName of validTagNames) {
        try {
          const tag = await tagService.createTag(tagName);
          if (tag) {
            results.push(tag);
          }
        } catch (singleError) {
          console.error(`处理标签 "${tagName}" 失败:`, singleError);
          // 即使单个标签失败，也不要阻止整个流程
        }
      }
      return results;
    }
  }
};

export default tagService;